import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-close-icon',
  templateUrl: 'close.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CloseIcon {}
